import { mergeStyles } from '@uifabric/merge-styles'
import React from 'react'

const style = mergeStyles({
	display: 'flex',
	marginTop: 12,
	marginBottom: 16,
	justifyContent: 'center',
	color: '#333',
	'selectors': {
		'div': {
			marginLeft: 24,
		},
		'div:first-child': {
			marginLeft: 0,
		}
	}
})

export const AdviceText = () => (
	<div className={style}>
		<div>Paste whatever text you like with Ctrl-V or Cmd-V</div>
		<div>Start a new practice session with Ctrl-R</div>
	</div>
)